// alterado - revisado

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import tipoCondicaoSaudeList from '../../../business-rules/List/tipoCondicaoSaudeList'



export const processaRegistrosDefaultIniciaisCondicaoSaude = ( values, familiar ) => {

    if (familiar) {
        if (!values.familiaresProcessouRegistrosDefaultIniciaisCondicaoSaude) {
            values.familiaresProcessouRegistrosDefaultIniciaisCondicaoSaude = []
        }

        if (!values.condicaoSaude) {
            values.condicaoSaude = []
        }
        
        if (!pesquisaList(values.familiaresProcessouRegistrosDefaultIniciaisCondicaoSaude, familiar).id) {

            values.familiaresProcessouRegistrosDefaultIniciaisCondicaoSaude.push(
                {
                    id: familiar
                }
            )

            values.condicaoSaude.push(
                {
                    familiar: familiar,
                }
            )
        }
    }
}



const calculaCondicaoSaudeDadosDoenca = ( item ) => {

    const informaDadosDoenca = pesquisaList(tipoCondicaoSaudeList, item.tipoCondicaoSaude).informaDadosDoenca

    if (informaDadosDoenca !== "S") {
        item.idadeDesdeDoenca = ''
        item.tipoSituacaoDoenca = ''
    }
}

const calculaCondicaoSaudeDadosCirurgia = ( item ) => {
    
    const informaDadosCirurgia = pesquisaList(tipoCondicaoSaudeList, item.tipoCondicaoSaude).informaDadosCirurgia

    if (informaDadosCirurgia !== "S") {
        item.idadeCirurgia = ''
        item.procedimentoCirurgia = ''
    }
}

export const processaAlteracaoCondicaoSaudeTipoCondicaoSaude = ( item ) => {

    calculaCondicaoSaudeDadosDoenca(item)
    calculaCondicaoSaudeDadosCirurgia(item)
}